import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
//Redux
import { useDispatch } from "react-redux";
import { setComponentActive, setLoading } from "../../../../reducers/userConfigSlice";
//Components
import { LuArrowLeft } from "react-icons/lu";
import { formatMoney } from "../../../../functions/money";
import { MdOutlineDeliveryDining, MdRestaurantMenu, MdCheckCircleOutline, MdStorefront } from "react-icons/md";
import "./style.css";
import "./tracking-design.css";
//Api
import { getTrackCustomerOrder } from "../../../../api/shop";
import { renderOrderTimeline } from "./utils";
import { PaymentGateway } from "../../../../hooks/paymentGateway";
import { OrderNotes } from "@delibrandev/utils";
import { useSelector } from "react-redux";

export const OrderTraking = () => {
  const reCallInMs = 10000;

  const paramsUrl = useParams();
  const paymentsMethods = useSelector((state) => state.aplicationConfig.corporationData?.info?.corporation?.historicalPaymentMethods || state.aplicationConfig.corporationData?.info?.corporation?.PaymentMethods);
  //const order = useSelector((state) => state.aplicationConfig.userConfig.historyOrder);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setOrderLoading] = useState(true);
  //console.log("order > ", order);


  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleMenu = (component) => {
    dispatch(setComponentActive(component));
    navigate("/" + component);
  };

  useEffect(() => {
    let active = true;
    let pending = false;
    setData(null);
    setError("");
    setOrderLoading(true);
    const queryGet = async () => {
      if (pending) return;
      pending = true;
      try {
        const response = await getTrackCustomerOrder(paramsUrl.id);
        if (!active) return;
        if (response?.error !== false || !response.data?.orderLog) {
          setData(null);
          setError("No se puede consultar este pedido en esta tienda con tu cuenta.");
        } else {
          setError("");
          setData(response.data);
        }
      } catch {
        if (active) {
          setData(null);
          setError("No se pudo cargar el pedido. Vuelve al historial e inténtalo de nuevo.");
        }
      } finally {
        pending = false;
        if (active) setOrderLoading(false);
      }
    };
    queryGet();
    const interval = setInterval(queryGet, reCallInMs);
    return () => { active = false; clearInterval(interval); };
  }, [paramsUrl.id]);

  /***********************************************
    / Este componente carga los datos de un pedido
    / y los monta en la pasarela de pago Stripe
    ***********************************************/
  const OrderPayment = () => {
    const fullname = useSelector((state) => state.aplicationConfig.userConfig.userData.fullname);
    const email = useSelector((state) => state.aplicationConfig.userConfig.userData.email);

    const paymentMethod = (paymentsMethods || []).filter((method) => method.name === "Tarjeta de crédito")[0];
    const orderId = data?.orderLog?.orderId;
    const paymentData = () => {
      return {
        orderId: orderId,
        name: fullname,
        email: email,
        paymentMethodId: paymentMethod.paymentMethodId,
        discountedTotal: data?.orderLog.discountedTotal,
        total: data?.orderLog.total,
        amounts: data?.orderLog.amounts,
        urlCallback: "/order-tracking/" + orderId,
        cancelLoading: () => dispatch(setLoading(false)),
        functionCallback: () => navigate("/order-tracking/" + orderId),
      };
    };
    return (
      <>
        <PaymentGateway callback={paymentData} />
      </>
    );
  };
  /*******************************************/

  const OrderTimeline = () => {
    const orderLog = data?.orderLog;
    const status = orderLog?.status;

    const TrackingScene = () => {
      if (status === "pending") {
        return (
          <div className="tracking-scene tracking-scene-pending">
            <MdStorefront className="store-icon" />
            <div className="preparation-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className="tracking-label">Pedido recibido</div>
          </div>
        );
      }

      if (status === "inPreparation") {
        return (
          <div className="tracking-scene tracking-scene-preparation">
            <MdRestaurantMenu className="kitchen-icon" />
            <div className="steam">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className="tracking-label">Preparando pedido</div>
          </div>
        );
      }

      if (status === "prepared") {
        return (
          <div className="tracking-scene tracking-scene-prepared">
            <MdCheckCircleOutline className="ready-icon" />
            <div className="tracking-label">Pedido preparado</div>
          </div>
        );
      }

      if (status === "inDelivery") {
        return (
          <div className="tracking-scene tracking-scene-delivery">
            <MdOutlineDeliveryDining className="moto-icon" />
            <div className="road"></div>
            <div className="tracking-label">Repartidor en camino</div>
          </div>
        );
      }

      if (status === "delivered") {
        return (
          <div className="tracking-scene tracking-scene-delivered">
            <MdCheckCircleOutline className="delivered-icon" />
            <div className="tracking-label">Pedido entregado</div>
          </div>
        );
      }

      return (
        <div className="tracking-scene tracking-scene-terminal">
          <MdStorefront className="store-icon-static" />
          <div className="tracking-label">Consulta el estado de tu pedido</div>
        </div>
      );
    };

    return <>
      <div className="tracking-animation" aria-live="polite"><TrackingScene /></div>
      <div className="timeline-container"><ul className="timeline">{renderOrderTimeline(orderLog?.status, orderLog?.updatedAt, undefined, orderLog?.fulfillment?.type)}</ul></div>
    </>;
  };

  const OrderProducts = ({ data: order }) => {
    const amounts = order.amounts;
    const grossSubtotal = Number.isFinite(amounts?.subtotalWithTax);
    const money = value => Number.isFinite(value) ? formatMoney(value) : "—";
    return <section className="account-panel tracking-order-summary" aria-label="Resumen del pedido">
      <h2>Resumen del pedido</h2>
      {(order.products || []).map((product, index) => <div className="tracking-product" key={product.cartLineId || index}>
        <div className="tracking-product-copy"><h3>{product.name || "Producto"} <span>×{product.quantity}</span></h3>
          {product.variantName && <p>{product.variantName}</p>}
          {Array.isArray(product.items) && <p>{product.items.map(item => item.name).filter(Boolean).join(" · ")}</p>}
          {product.note && <p>{product.note}</p>}
        </div><strong>{money(product.lineTotalWithTax)}</strong>
      </div>)}
      <div className="tracking-totals">
        {Number.isFinite(grossSubtotal ? amounts?.subtotalWithTax : amounts?.subtotal) && <div><span>{grossSubtotal ? "Subtotal" : "Subtotal sin IVA"}</span><span>{money(grossSubtotal ? amounts.subtotalWithTax : amounts.subtotal)}</span></div>}
        {!grossSubtotal && Number.isFinite(amounts?.tax) && <div><span>IVA</span><span>{money(amounts.tax)}</span></div>}
        {Number.isFinite(amounts?.shipping) && amounts.shipping !== 0 && <div><span>Envío</span><span>{money(amounts.shipping)}</span></div>}
        {Number.isFinite(amounts?.discountsWithTax) && amounts.discountsWithTax !== 0 ? <div><span>Descuento</span><span>−{money(amounts.discountsWithTax)}</span></div> : Number.isFinite(amounts?.discounts) && amounts.discounts !== 0 && <div><span>Descuento sin IVA</span><span>−{money(amounts.discounts)}</span></div>}
        <div className="tracking-total"><strong>Total</strong><strong>{Number.isFinite(amounts?.total) ? money(amounts.total) : "Importe pendiente de revisión"}</strong></div>
      </div>
    </section>;
  };

  useEffect(() => {
    dispatch(setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramsUrl]);

  const order = data?.orderLog;
  const orderLabels = { pending: "Recibido", inPreparation: "En preparación", prepared: "Preparado", inDelivery: "En camino", delivered: "Entregado", notDelivered: "No entregado", cancelled: "Cancelado", canceled: "Cancelado", abandoned: "Abandonado", returned: "Devuelto" };
  const paymentLabels = { pending: "Pendiente", paid: "Pagado", failed: "Fallido" };
  const created = new Date(order?.createdAt);
  return <main className="profile-container account-tracking">
    <Link to="/history" className="tracking-back" onClick={() => dispatch(setComponentActive("history"))}><LuArrowLeft aria-hidden="true" />Volver a mis pedidos</Link>
    <h1 className="tracking-title">{order ? `Pedido #${order.displayNumber ?? order.number}` : "Seguimiento del pedido"}</h1>
    {loading && <p role="status">Cargando pedido…</p>}
    {error && <div role="alert" className="account-panel"><p>{error}</p><button type="button" className="account-secondary" onClick={() => handleMenu("history")}>Volver al historial</button></div>}
    {order?.paymentStatus === "pending" && (paymentsMethods || []).some(method => method.paymentMethodId === order.paymentMethod && method.name === "Tarjeta de crédito") && <section className="account-panel tracking-payment" aria-label="Pago pendiente"><h2>Pago pendiente</h2><p>Tu pedido está pendiente de pago. Puedes completarlo aquí.</p><OrderPayment /></section>}
    {order && <div className="order-tracking-body">
      <section className="account-panel tracking-progress" aria-label="Estado del pedido">
        <div className="tracking-status-header"><div><span className={`account-state state-${order.status}`}>{orderLabels[order.status] || "Estado no disponible"}</span><p>{Number.isFinite(created.getTime()) ? new Intl.DateTimeFormat("es", {day:"2-digit",month:"short",hour:"2-digit",minute:"2-digit"}).format(created) : "Fecha no disponible"}</p></div><p>Pago: <strong>{paymentLabels[order.paymentStatus] || "No disponible"}</strong></p></div>
        <OrderTimeline />
      </section>
      <section className="account-panel tracking-delivery" aria-label="Entrega"><h2>Entrega</h2><p>{[order.address?.street, order.address?.number, order.address?.floor, order.address?.door, order.address?.zipCode, order.address?.city, order.address?.state].filter(Boolean).join(", ") || "Dirección no disponible"}</p></section>
      <OrderProducts data={order} />
      {!!order.notes?.length && <section className="account-panel tracking-notes" aria-label="Notas del pedido"><h2>Notas del pedido</h2><OrderNotes data={order} /></section>}
    </div>}
  </main>;
};
